import { z } from 'zod'

import { makeGenericZodErrorMessage } from '@/utils/make-generic-zod-error-message'

const dateSchema = z.coerce
  .date(makeGenericZodErrorMessage('A data é obrigatória.'))
  .min(new Date('1900-01-01'), { message: 'Data muito antiga.' })
  .transform((value) => value.toJSON().split('T')[0])

const commonSchema = z.object({
  description: z.string().max(600, { message: 'Máximo de 600 caracteres' }),
})

const mappingSchema = z
  .object({
    activity_type: z.literal(
      'mapping',
      makeGenericZodErrorMessage('Campo obrigatório'),
    ),
    date: dateSchema,
    diagnosis_name: z
      .string()
      .min(1, 'O nome do diagnóstico é obrigatório.')
      .max(45, 'O nome do diagnóstico deve ter no máximo 45 caracteres.'),
    culture: z.enum(
      ['cane', 'soybean'],
      makeGenericZodErrorMessage('A seleção da cultura é obrigatória.'),
    ),
    treatment: z.enum(
      ['weed'],
      makeGenericZodErrorMessage('A seleção do diagnóstico é obrigatória.'),
    ),
  })
  .merge(commonSchema)

const pulverizationSchema = z
  .object({
    activity_type: z.literal(
      'pulverization',
      makeGenericZodErrorMessage('Campo obrigatório'),
    ),
    date: z
      .object({
        start_date: dateSchema,
        end_date: z.union([dateSchema, z.string()]),
      })
      .refine(
        (data) => {
          if (!data.end_date) return true
          return data.start_date <= data.end_date
        },
        {
          message: 'Data final deve ser maior que a data inicial.',
          path: ['end_date'],
        },
      ),
    diagnosis: z.object(
      {
        id: z.string().min(1, { message: 'Campo obrigatório' }),
        name: z.string().min(1, { message: 'Campo obrigatório' }),
      },
      makeGenericZodErrorMessage('Campo obrigatório'),
    ),
  })
  .merge(commonSchema)

export const schema = z.discriminatedUnion(
  'activity_type',
  [mappingSchema, pulverizationSchema],
  makeGenericZodErrorMessage('Campo obrigatório'),
)

export type MappingActivityForm = z.infer<typeof mappingSchema>
export type PulverizationActivityForm = z.infer<typeof pulverizationSchema>
export type DefaultNewActivityForm = z.infer<typeof schema>
